define('views/microshop-master-order-view',['jquery', 'utils/view', 'connections/microshop-connection', 'settings'], function (
  $,
  View,
  MicroshopConnection,
  settings
) {
  var _this;
  var MicroshopMasterOrderView = (function () {
    function MicroshopMasterOrderView($container) {
      _this = this;
      _this.container = $container;
      _this.shopId = $container.data('shopId');
      _this.orderId = $container.data('orderId');
    }

    MicroshopMasterOrderView.prototype.init = function () {
      _this.bindConfirmMasterOrder();
      _this.bindRemoveMasterOrder();
    };

    MicroshopMasterOrderView.prototype.bindRemoveMasterOrder = function () {
      $('[data-action="removeMasterOrder"]').on('click', function (e) {
        e.stopPropagation();

        MicroshopConnection.removeMasterOrder(_this.shopId, _this.orderId).then(function () {
          window.location.href = settings.microshop + 'orders?shopId=' + _this.shopId;
        });
      });
    };

    MicroshopMasterOrderView.prototype.bindConfirmMasterOrder = function () {
      _this.container.find('[data-action="confirmMasterOrder"]').on('click', function (e) {
        e.stopPropagation();

        window.location.href = settings.cartPageUrl + 'order?order=' + _this.orderId;
      });
    };

    return MicroshopMasterOrderView;
  })();

  return View('MicroshopMasterOrderView', function () {
    var view = new MicroshopMasterOrderView($('[data-view="MicroshopMasterOrderView"]'));
    view.init();
  });
});

